import React from 'react';
import { createPortal } from 'react-dom';
import { UserWithRole, RoleHistory } from '../../../../../shared/services/userService';
import usePageTranslation from '../../../../../shared/hooks/usePageTranslation';

interface RoleHistoryModalProps {
  user: UserWithRole;
  history: RoleHistory[];
  onClose: () => void;
}

const RoleHistoryModal: React.FC<RoleHistoryModalProps> = ({ user, history, onClose }) => {
  const { t } = usePageTranslation('panel', 'UserRolesManagement');

  return createPortal(
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[9999] p-4">
      <div className="rounded-xl border border-[#243052]/90 bg-[#0a1128] p-6 shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto">
        <h3 className="text-lg font-bold text-white mb-5">
          {t('modal.history.title')} — {user.username}
        </h3>
        {history.length === 0 ? (
          <p className="text-slate-400 text-sm">{t('modal.history.noHistory')}</p>
        ) : (
          <div className="space-y-3">
            {history.map((item) => (
              <div
                key={item.id}
                className="rounded-lg border border-[#2b3a61] bg-[#0d1b3a]/80 p-4"
              >
                <div className="flex items-center justify-between mb-1.5">
                  <span className="text-white font-semibold text-sm">
                    {item.old_role_name} → {item.new_role_name}
                  </span>
                  <span className="text-slate-400 text-xs">
                    {new Date(item.created_at).toLocaleString('fr-FR')}
                  </span>
                </div>
                {item.reason && (
                  <p className="text-slate-400 text-xs mb-1">{item.reason}</p>
                )}
                <p className="text-slate-500 text-xs">
                  {t('modal.history.changedBy')} {item.changed_by_username}
                </p>
              </div>
            ))}
          </div>
        )}
        <button
          onClick={onClose}
          className="mt-5 w-full rounded-lg border border-white/15 bg-black/30 py-2.5 text-sm font-semibold text-slate-200 hover:bg-black/45 transition-colors"
        >
          {t('modal.history.close')}
        </button>
      </div>
    </div>,
    document.body
  );
};

export default RoleHistoryModal;
